import StatusPill from '../common/StatusPill';

const STATUS_META = {
  active: { label: 'Ativa', variant: 'success' },
  pending_payment: { label: 'Pendente', variant: 'warning' },
  past_due: { label: 'Em atraso', variant: 'warning' },
  suspended: { label: 'Suspensa', variant: 'danger' },
  cancelled: { label: 'Cancelada', variant: 'muted' },
  checkout_created: { label: 'Checkout gerado', variant: 'info' },
  paid: { label: 'Pagamento confirmado', variant: 'info' },
  provisioning: { label: 'Provisionando', variant: 'warning' },
  provisioned: { label: 'Provisionada', variant: 'success' },
  expired: { label: 'Expirada', variant: 'muted' },
  failed: { label: 'Falhou', variant: 'danger' },
  processed: { label: 'Processado', variant: 'success' },
  pending: { label: 'Pendente', variant: 'warning' }
};

const prettify = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) {
    return '-';
  }

  return normalized
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export default function BillingStatusBadge({ status }) {
  const normalized = String(status || '').trim().toLowerCase();
  const meta = STATUS_META[normalized] || { label: prettify(normalized), variant: 'info' };

  return <StatusPill label={meta.label} variant={meta.variant} />;
}
